import React, { useEffect, useState, useRef } from 'react';
interface TooltipProps {
  children: React.ReactNode;
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}
export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  position = 'top'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);
  // Calculate position based on the trigger element
  useEffect(() => {
    if (isVisible && tooltipRef.current && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const styles: React.CSSProperties = {};
      switch (position) {
        case 'top':
          styles.bottom = `calc(100% - ${triggerRect.top}px + 5px)`;
          styles.left = `${triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2}px`;
          break;
        case 'bottom':
          styles.top = `${triggerRect.bottom + 5}px`;
          styles.left = `${triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2}px`;
          break;
        case 'left':
          styles.right = `calc(100% - ${triggerRect.left}px + 5px)`;
          styles.top = `${triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2}px`;
          break;
        case 'right':
          styles.left = `${triggerRect.right + 5}px`;
          styles.top = `${triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2}px`;
          break;
      }
      Object.assign(tooltipRef.current.style, styles);
    }
  }, [isVisible, position]);
  return <div className="relative inline-block" data-id="element-825">
      <div ref={triggerRef} onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} className="cursor-help" data-id="element-826">
        {children}
      </div>
      {isVisible && <div ref={tooltipRef} className={`absolute z-50 px-2 py-1 text-xs font-normal text-white bg-gray-800 rounded shadow-sm max-w-xs whitespace-normal ${position === 'top' ? 'mb-1' : position === 'bottom' ? 'mt-1' : position === 'left' ? 'mr-1' : 'ml-1'}`} style={{
      width: 'max-content',
      maxWidth: '200px'
    }} data-id="element-827">
          {content}
          <div className={`absolute w-2 h-2 bg-gray-800 transform rotate-45 ${position === 'top' ? 'bottom-0 translate-y-1/2' : position === 'bottom' ? 'top-0 -translate-y-1/2' : position === 'left' ? 'right-0 translate-x-1/2' : 'left-0 -translate-x-1/2'}`} style={{
        left: position === 'top' || position === 'bottom' ? '50%' : undefined,
        top: position === 'left' || position === 'right' ? '50%' : undefined,
        transform: `${position === 'top' || position === 'bottom' ? 'translateX(-50%)' : ''} ${position === 'left' || position === 'right' ? 'translateY(-50%)' : ''} rotate(45deg)`
      }} data-id="element-828" />
        </div>}
    </div>;
};